var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationlocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16V26H17",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.86 12.249L16 5L5 14",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 18.8153C27 21.1813 23 24.9983 23 24.9983C23 24.9983 19 21.1813 19 18.8153C19.0069 18.3004 19.1164 17.7922 19.3222 17.3202C19.5279 16.8482 19.8258 16.422 20.1983 16.0666C20.5707 15.7111 21.0104 15.4336 21.4915 15.2501C21.9726 15.0667 22.4854 14.9811 23 14.9983C23.5146 14.9811 24.0274 15.0667 24.5085 15.2501C24.9896 15.4336 25.4293 15.7111 25.8017 16.0666C26.1742 16.422 26.4721 16.8482 26.6778 17.3202C26.8836 17.7922 26.9931 18.3004 27 18.8153V18.8153Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19C23.5 19.2761 23.2761 19.5 23 19.5C22.7239 19.5 22.5 19.2761 22.5 19C22.5 18.7239 22.7239 18.5 23 18.5C23.2761 18.5 23.5 18.7239 23.5 19Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationlocation);
export default __webpack_public_path__ + "static/media/Locationlocation.267bfd3108b2df17356d8e59f8dc8b85.svg";
export { ForwardRef as ReactComponent };